import Enum from '@/modules/core/app/helpers/Enum';

export class GeminiModel extends Enum {
  key!: string;
  value!: string;

  static GEMINI_2_0_FLASH = {
    key: 'gemini-2.0-flash',
    get value(): string {
      return 'Gemini 2.0 Flash';
    }
  };

  static GEMINI_2_0_FLASH_LITE = {
    key: 'gemini-2.0-flash-lite',
    get value(): string {
      return 'Gemini 2.0 Flash Lite';
    }
  };

  static GEMINI_2_5_FLASH = {
    key: 'gemini-2.5-flash',
    get value(): string {
      return 'Gemini 2.5 Flash';
    }
  };

  static GEMINI_2_5_FLASH_LITE = {
    key: 'gemini-2.5-flash-lite',
    get value(): string {
      return 'Gemini 2.5 Flash Lite';
    }
  };

  static GEMINI_2_5_PRO = {
    key: 'gemini-2.5-pro',
    get value(): string {
      return 'Gemini 2.5 Pro';
    }
  };

  static GEMINI_3_PRO = {
    key: 'gemini-3-pro-preview',
    get value(): string {
      return 'Gemini 3 Pro';
    }
  };

  static GEMINI_3_FLASH = {
    key: 'gemini-3-flash-preview',
    get value(): string {
      return 'Gemini 3 Flash';
    }
  };

  static GEMINI_3_1_PRO = {
    key: 'gemini-3.1-pro-preview',
    get value(): string {
      return 'Gemini 3.1 Pro';
    }
  };

  static GEMINI_3_1_FLASH_LITE = {
    key: 'gemini-3.1-flash-lite',
    get value(): string {
      return 'Gemini 3.1 Flash Lite';
    }
  };

  static GEMINI_3_5_FLASH = {
    key: 'gemini-3.5-flash',
    get value(): string {
      return 'Gemini 3.5 Flash';
    }
  };

  static GEMINI_3_5_FLASH_LITE = {
    key: 'gemini-3.5-flash-lite',
    get value(): string {
      return 'Gemini 3.5 Flash Lite';
    }
  };

  static GEMINI_3_6_FLASH = {
    key: 'gemini-3.6-flash',
    get value(): string {
      return 'Gemini 3.6 Flash';
    }
  };
}
